exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Moduleholder {\n  text-align: left; }\n  .Moduleholder.default {\n    height: calc(100vH - 100px);\n    position: absolute;\n    top: 100px;\n    width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/moduleholder/Moduleholder.scss
// module id = 307
// module chunks = 51